import http from '@/http'

const PATH = '/tools/bundles'

export default {
    /**
     * @param {{}} params
     * @returns {Promise<void>}
     */
    async listBundles (params) {
        try {
            const response = await http.get(PATH, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {BundleQuery} data
     * @returns {Promise<void>}
     */
    async showBundle (data) {
        try {
            const response = await http.get(`${PATH}/${data.id}`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
